import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Welcome from './pages/Welcome';
import OAuthCallback from './pages/OAuthCallback';
import PackageAndDeploy from './pages/PackageAndDeploy';
import Documentation from './pages/Documentation';
import Support from './pages/Support';
import './App.css';

// Protected route component
function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/oauth-callback" element={<OAuthCallback />} />
            <Route
              path="/package-deploy"
              element={
                <ProtectedRoute>
                  <PackageAndDeploy />
                </ProtectedRoute>
              }
            />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/support" element={<Support />} />
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;
